import * as React from 'react';
import { FC } from 'react';

import { isServiceRewardDetails } from 'state/loyalty/in-restaurant-redemption';
import { maybeLocale } from 'utils/graphql';

import { StyledPicture } from './styled';
import { IItemPictureProps } from './types';

export const OfferItemPicture: FC<IItemPictureProps<'offer'>> = ({
  entryCartDetails: { offer },
  ...props
}) => (
  <StyledPicture
    {...props}
    alt={offer?.localizedImage?.locale?.imageDescription || ''}
    image={offer?.localizedImage?.locale?.app}
  />
);

export const RewardItemPicture: FC<React.PropsWithChildren<IItemPictureProps<'reward'>>> = ({
  entryCartDetails,
  ...props
}) => {
  const reward = entryCartDetails.reward;
  const alt = isServiceRewardDetails(entryCartDetails)
    ? entryCartDetails.reward.imageDescription || entryCartDetails.reward.name
    : maybeLocale(entryCartDetails.reward.imageDescription) ||
      maybeLocale(entryCartDetails.reward.name) ||
      '';

  return (
    // @ts-expect-error TS(2769) FIXME: No overload matches this call.
    <StyledPicture {...props} alt={alt} image={maybeLocale(reward.image)} />
  );
};
